import { render } from "./GalleryListComponent.vue?vue&type=template&id=40c3fc2f&ts=true"
import script from "./GalleryListComponent.vue?vue&type=script&lang=ts"
export * from "./GalleryListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__